var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.ticketList && _vm.ticketList.length > 0
      ? _c("p", [_vm._v("关联工单")])
      : _vm._e(),
    _vm._v(" "),
    _vm.ticketList && _vm.ticketList.length > 0
      ? _c(
          "div",
          { staticClass: "box-border-7" },
          _vm._l(_vm.ticketList, function(each) {
            return _c(
              "div",
              {
                key: each.id,
                staticStyle: {
                  "white-space": "nowrap",
                  "text-overflow": "ellipsis",
                  overflow: "hidden"
                }
              },
              [
                _c("TicketTitle", {
                  attrs: {
                    ticketTitle: each.orderTitle,
                    ticketNo: each.orderId,
                    target: "_blank"
                  }
                })
              ],
              1
            )
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-554d7ca6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-554d7ca6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/LinkedTicketList.vue
// module id = 1026
// module chunks = 75